import { ReactNode } from 'react'
import { BottomTabBar } from './BottomTabBar'
import { Sidebar } from './Sidebar'

interface AppLayoutProps {
  children: ReactNode
}

/**
 * Authenticated app shell.
 * Mobile: content + fixed bottom tab bar.
 * Desktop (lg+): sidebar on the left + content area.
 */
export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Desktop sidebar */}
      <Sidebar />

      {/* Main content — offset by sidebar width on desktop */}
      <main className="lg:pl-64 pb-20 lg:pb-0 min-h-screen">
        {children}
      </main>

      {/* Mobile bottom tab bar */}
      <BottomTabBar />
    </div>
  )
}
